export default __webpack_public_path__ + "static/media/logo1 (1).c02ae098.png";